import { NotifyData } from "../../data/notifyData";
import { AuthorizationsHistoryData } from "../../data/authorizationsHistoryData";
import { ChatMeassagesData } from "../../data/chatMeassagesData";
import { PersonInfoModel } from "../../models/person/personInfoModel";
import { clientTime } from "../../utilities/index";
import {UserSubscriptionData} from '../../data/userSubscriptionData';
import {DocumentTypeData} from '../../data/documentTypeData';
import { ServerProcessData } from '../../data/serverProcessData';
import { Http } from "./http";

/** Запросы к методам получения данных клиента */
export class PersonApi {
  /**
   * Получение уведомлений
   * @returns Объект NotifyData
   */
  static async syncNotificationsData(): Promise<Array<NotifyData>> {
    const respData = await Http.get(
      `WebClient/GetShortMessageData?clientTime=${clientTime()}&typeSource=0`
    );
    const res: Array<NotifyData> = [];
    respData.data.forEach((not: any) => {
      if (not) {
        res.push(new NotifyData(not));
      }
    });
    return res;
  }

  /**
   * Удаление аватара пользователя 
   * */
  public static async removeAvatar(): Promise<boolean> {
    const formData = new FormData();

    formData.append('clientTime', clientTime());

    // Выполняем запрос.
    const respData = await Http.post("Profile/DeleteAvatar", formData);

    return respData.result === 'ok' ? true : false;
  }

  /**
  * Получение списка подписок клиента.
  * @returns Список подписок клиента.
  */
  public static async getUserSubscriptions(): Promise<Array<UserSubscriptionData>> {
    const subscriptions: Array<UserSubscriptionData> = [];
    let respData = await Http.get(`WebClient/GetUserSubscriptions?clientTime=${clientTime()}&typeSource=0`);
    if (respData.data.length > 0 && respData.data !== undefined) {
      respData.data.forEach((item: any) => {
        subscriptions.push(new UserSubscriptionData(item));
      });
    }
    return subscriptions;
  }

  /**
* Удаление подписки пользователя.
* @param operationId ИД подписки. 
* @returns Задача.
*/
  public static async hideUserSubscriptionAsync(subscriptionId: number): Promise<void> {
    // Проверки.

    await Http.get(`mobile/HideUserSubscription?subscriptionId=${subscriptionId}&clientTime=${clientTime()}&typeSource=0`);

  }

  /**
  * Получение списка типов документов.
  * @returns Список типов документов.
  */
  public static async getUserDocumentTypes(): Promise<Array<DocumentTypeData>> {
    const documentTypes: Array<DocumentTypeData> = [];
    let respData = await Http.get(`WebClient/GetUserDocumentTypes?clientTime=${clientTime()}&typeSource=0`);
    if (respData.data.length > 0 && respData.data !== undefined) {
      respData.data.forEach((item: any) => {
        documentTypes.push(new DocumentTypeData(item));
      });
    }
    return documentTypes;
  }

  /**
   * Получение данных Aклиента
   * @returns Объект PersonInfoModel
   */
  static async syncPersonInfo(): Promise<PersonInfoModel> {
    const respData = await Http.get(
      `WebClient/GetPersonInfo?clientTime=${clientTime()}&typeSource=0`
    );

    return new PersonInfoModel(respData?.data);
  }

  static async syncSetAvatar(file: any): Promise<any> {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("clientTime", clientTime());
    const res = await Http.post(`Profile/SetAvatar`, formData);

    return res.data || "";
  }

  static async syncSetAlias(alias: string): Promise<any> {
    return await Http.get(
      `WebClient/ChangeAlias?alias=${alias}&clientTime=${clientTime()}&typeSource=0`
    );
  }

  /**
   * Получение уведомления.
   * @param id Внутренний ИД уведомления.
   * @returns Уведомление.
   */
  static async getNotifyDetail(id: number): Promise<NotifyData> {
    // получаем подробные данные конкретного уведомления.
    const respData = await Http.get(
      `WebClient/GetMessageData?messageId=${id.toString()}&clientTime=${clientTime()}&typeSource=0`
    );

    // парсим данные
    return new NotifyData(respData?.data);
  }

  /**
   * Смена статуса уведомления.
   * @param id Внутренний ИД уведомления.
   */
  public static async checkNotify(id: number): Promise<void> {
    await Http.get(
      `WebClient/EditMessageStatus?messageId=${id.toString()}&state=2&clientTime=${clientTime()}&typeSource=0`
    );
  }

  /**
   * Удаление уведомления.
   * @param id Внутренний ИД уведомления.
   */
  public static async deleteNotify(id: number): Promise<void> {
    await Http.get(
      `WebClient/EditMessageStatus?messageId=${id.toString()}&state=3&clientTime=${clientTime()}&typeSource=0`
    );
  }

  public static async authHistory(
    take: number,
    skip: number,
    dateBegin: string,
    dateEnd: string
  ): Promise<Array<AuthorizationsHistoryData>> {
    const lastDate = dateEnd ? dateEnd : dateBegin ? dateBegin : new Date();
    const startDate = dateBegin ? dateBegin : dateEnd ? dateEnd : new Date().setMonth(new Date().getMonth() - 1);
    const res = await Http.get(
      `WebClient/GetAuthorizationsHistory?take=${take}&skip=${skip}&begin=${new Date(
        startDate
      ).toISOString().substring(0,10)}&end=${new Date(
        lastDate
      ).toISOString().substring(0,10)}&clientTime=${clientTime()}&typeSource=0`
    );
    return res.data.map((item: any) => new AuthorizationsHistoryData(item));
  }

  /**
   * Получение сообщений чата.
   * @returns сообщения.
   */
  static async getEFrontChatMessages(): Promise<Array<ChatMeassagesData>> {
    const messagesList: Array<ChatMeassagesData> = [];
    const respData = await Http.get(
      `/BankChat/Refresh`
    );
    if (respData.data !== null && respData.data.length > 0) {
      respData.data.forEach((mes: any) => {
        messagesList.push(new ChatMeassagesData(mes));
      });
    }    

    return messagesList;
  }


    /**
   * Получение сообщений чата.
   * @returns сообщения.
   */
    static async getChatMessages(): Promise<Array<ChatMeassagesData>> {
      const messagesList: Array<ChatMeassagesData> = [];
      const respData = await Http.get(
        `/BankChat/Refresh`
      );
      if (respData.data !== null && respData.data.length > 0) {
        respData.data.forEach((mes: any) => {
          messagesList.push(new ChatMeassagesData(mes));
        });
      }    
  
      return messagesList;
    }

  /**
   * Отправка сообщения чата.
   * @params
   * @text текст сообщения
   * @returns сообщения.
   */
  static async sendChatMessage(text: string) {
    const messagesList: Array<ChatMeassagesData> = [];
    const respData = await Http.get(
      `/BankChat/Send?text=${text}`,
    );

    if (respData.result !== 'error') {
      return this.getChatMessages();
    }
    return null;
  }


  /**
   * Получения истории заявок
   * @returns Массив заявок.
   */
  static async getServerProcesses(): Promise<Array<ServerProcessData>> {

    const serverProcesses: Array<ServerProcessData> = [];

    const res = await Http.get(`WebClient/GetServerProcesses?take=-1&skip=-1&dateBegin=&dateEnd=&clientTime=2021/12/02%2016:41:50&typeSource=0`);

    if (res.data && res.data.length) {
      for (const key in res.data) {
        const item: any = res.data[key];
        if (item) {
          serverProcesses.push(new ServerProcessData(item));
        }
      }
    }

    return serverProcesses;
  }


}
